import { connect } from 'react-redux';
import { flow } from 'fp-ts/function';
import { composeProps, createPropsExtender } from '@mews/framework';
import { getCultureCode } from '@mews-commander/core';
import { NumberMask } from '@optimus-web/core';
import { getCurrentNumberCultureInfo } from '@mews-commander/core/legacy-globalization';

const setAlternativeDecimalSeparator = ({ decimalSeparator, ...other }: $TSFixMe) => ({
    alternativeDecimalSeparator: decimalSeparator === '.' ? ',' : '.',
    decimalSeparator,
    ...other,
});

const createNumberMaskConfigurationSelector = (additionalConfiguration = {}) =>
    flow(
        composeProps(
            getCurrentNumberCultureInfo,
            createPropsExtender('cultureCode', () => getCultureCode())
        ),
        setAlternativeDecimalSeparator,
        (configuration) => ({ ...configuration, ...additionalConfiguration })
    );

const createNumberMaskSelector = (additionalConfiguration: $TSFixMe) =>
    flow(
        createNumberMaskConfigurationSelector(additionalConfiguration),
        (configuration) => new NumberMask(configuration)
    );

export default connect((state) => ({
    // @ts-expect-error $TSFixMeError: Expected 2 arguments, but got 1.
    numberMask: createNumberMaskSelector({ allowNegativeNumber: false, precision: 8 })(state),
    // @ts-expect-error $TSFixMeError: Spread types may only be created from object types.
    ...getCurrentNumberCultureInfo(state),
}));
